<!-- 平台查看多控销售统计 --  报表 -->
<template>
  <div class="pl-sales-statistic-table">
    <div class="pl-sales-statistic-search-form">
      <el-form
        :inline="true"
        :model="searchForm"
        class="pl-sales-statistic-form"
      >
        <!-- 代金券名称 -->
        <el-form-item label="">
          <el-input
            v-model="searchForm.name"
            placeholder="代金券名称"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 开始时间，结束时间 -->
        <el-form-item label="">
          <el-date-picker
            v-model="searchForm.searchTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 筛选使用门槛 -->
        <el-form-item label="">
          <el-input
            v-model.number="searchForm.useLimitStart"
            placeholder="最小门槛"
            size="small"
            style="width: 100px"
          ></el-input>
          ~
          <el-input
            v-model.number="searchForm.useLimitEnd"
            placeholder="最大门槛"
            size="small"
            style="width: 100px"
          ></el-input>
        </el-form-item>
        <!-- 筛选状态 -->
        <el-form-item label="">
          <el-select
            v-model="searchForm.state"
            placeholder="筛选状态"
            size="small"
            style="width: 110px"
            clearable
          >
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getList(1)" size="small"
            >查询</el-button
          >
          <el-button type="default" @click="resetForm" size="small"
            >重置</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="handleAdd" size="small"
            >新建</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <myTable
      :selection="false"
      :page="page"
      :showpage="true"
      v-loading="isLoading"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
    >
      <!-- 有效时间 -->
      <template slot="expireTime" slot-scope="scope">
        <!-- <el-statistic
          v-if="scope.row.endDate"
          format="DD天HH小时mm分钟"
          :value="getExpireTime(scope.row.endDate)"
          time-indices
          :value-style="{ color: 'red', fontSize: '14px' }"
        >
        </el-statistic> -->
        <span style="color: #f5222d">
          {{ getExpireTimeStr(scope.row.endDate) }}
        </span>
      </template>
      <!-- 使用门槛 useLimitType == 0 显示 0 ，useLimitType == 1 显示 useLimitAmount -->
      <template slot="useLimitType" slot-scope="scope">
        <span v-if="scope.row.useLimitType === 0">0</span>
        <span v-else>{{
          scope.row.useLimitAmount
            ? parseFloat(scope.row.useLimitAmount).toFixed(2)
            : "0.00"
        }}</span>
      </template>
      <!-- 使用条件 useWay 0,一次用完 1，多次使用 -->
      <template slot="useWay" slot-scope="scope">
        <span v-if="scope.row.useWay === 0">一次用完</span>
        <span v-else>多次使用</span>
      </template>
      <!-- 状态 -->
      <template slot="state" slot-scope="scope">
        <span>{{ stateMap[scope.row.state] }}</span>
      </template>
      <template slot="operation" slot-scope="scope">
        <el-button
          type="text"
          size="mini"
          @click="handleGoDetail(scope.$index)"
          v-if="scope.row.state !== 0"
          >详情</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleGoGoodsList(scope.$index)"
          v-if="scope.row.state !== 0"
          >商品列表</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleStop(scope.$index)"
          v-if="scope.row.state === 1 || scope.row.state === 2"
          >停用</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleRevoke(scope.$index)"
          v-if="scope.row.state === 3 || scope.row.state === 4"
          >作废</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleEdit(scope.$index)"
          v-if="scope.row.state === 0"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handlePublish(scope.$index)"
          v-if="scope.row.state === 0"
          >发布</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(scope.$index)"
          v-if="scope.row.state === 0"
          >删除</el-button
        >
      </template>
    </myTable>
    <voucher-add-dlg ref="voucherAddDlgRef" @refresh="getList(1)">
    </voucher-add-dlg>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import voucherAddDlg from "./component/voucherAddDlg.vue";
import _ from "lodash";
import {
  getVoucherInfoPage,
  publishVoucherInfo,
  cancelVoucherInfo,
  stopVoucherInfo,
  deleteVoucherInfo,
} from "@/api/voucher";
import dayjs from "dayjs";
export default {
  name: "PlSalesStatisticTable",
  components: {
    myTable,
    voucherAddDlg,
  },
  data() {
    return {
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "代金券名称", prop: "name", width: 150 },
        { label: "有效时间", prop: "endDate", width: 100 },
        {
          label: "距失效",
          prop: "expireTime",
          width: 200,
          slot: true,
          align: "center",
        },
        { label: "单张面额", prop: "amount", minWidth: 100 },
        { label: "使用门槛", prop: "useLimitType", minWidth: 100, slot: true },
        { label: "使用条件", prop: "useWay", minWidth: 100, slot: true },
        { label: "总量", prop: "maxSendQty", minWidth: 100 },
        { label: "已发", prop: "alreadySend", minWidth: 100 },
        { label: "已用", prop: "alreadyUsed", minWidth: 100 },
        { label: "已补贴金额", prop: "alreadySubsidy", minWidth: 100 },
        { label: "参加店铺总数", prop: "joinShopQty", minWidth: 100 },
        { label: "参加SKU总数", prop: "joinSkuQty", minWidth: 100 },
        { label: "状态", prop: "state", minWidth: 100, slot: true },
        { label: "创建人", prop: "createBy", minWidth: 100 },
        { label: "创建时间", prop: "createTime", minWidth: 100 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 150,
        },
      ],
      isLoading: false, //loading
      searchForm: {
        name: "",
        searchTime: "",
        useLimitStart: "",
        useLimitEnd: "",
        state: "",
      },
      // 状态（0草稿中，1待开始，2已开始，3已结束，4已停用，5已作废）
      stateMap: {
        0: "草稿中",
        1: "待开始",
        2: "已开始",
        3: "已结束",
        4: "已停用",
        5: "已作废",
      },
      stateList: [],
    };
  },
  created() {
    this.getList(1);
    // 转换 stateMap 格式
    this.transformStateMap();
  },
  methods: {
    // 转换 stateMap 格式
    transformStateMap() {
      for (let key in this.stateMap) {
        this.stateList.push({
          value: key,
          label: this.stateMap[key],
        });
      }
    },
    // 新增
    handleAdd() {
      this.$refs.voucherAddDlgRef.publicOpen();
    },
    // 编辑
    handleEdit(index) {
      const row = this.tableData[index];
      this.$refs.voucherAddDlgRef.publicEditOpen(row.id);
    },
    // 详情
    handleGoDetail(index) {
      const row = this.tableData[index];
      this.$refs.voucherAddDlgRef.publicViewOpen(row.id);
    },
    // 删除
    handleDelete(index) {
      const row = this.tableData[index];
      this.$alert(`您将删除“${row.name}”，是否确认？`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        type: "warning",
        // 自定义类名
        customClass: "top-icon-messagebox",
      })
        .then(() => {
          deleteVoucherInfo(row.id)
            .then((res) => {
              this.$message.success("删除成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 发布
    handlePublish(index) {
      const row = this.tableData[index];
      this.$alert(`是否确认发布“${row.name}”，发布后不可编辑！`, "发布", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        type: "warning",
        // 自定义类名
        customClass: "top-icon-messagebox",
      })
        .then(() => {
          publishVoucherInfo(row.id)
            .then((res) => {
              this.$message.success("发布成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("发布失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 停用
    handleStop(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将停用“${row.name}”，停用后不影响已发出的券，是否确认？`,
        "停用",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
          // 自定义类名
          customClass: "top-icon-messagebox",
        }
      )
        .then(() => {
          stopVoucherInfo(row.id)
            .then((res) => {
              this.$message.success("停用成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("停用失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 作废
    handleRevoke(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将作废“${row.name}”已发出但未使用的券，是否确认？`,
        "作废",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
          // 自定义类名
          customClass: "top-icon-messagebox",
        }
      )
        .then(() => {
          cancelVoucherInfo(row.id)
            .then((res) => {
              this.$message.success("作废成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("作废失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 商品列表
    handleGoGoodsList(index) {
      const row = this.tableData[index];
      this.$router.push({
        path: "/shopOperationCenter/platActivityManage-voucherGoodsList",
        query: { voucherId: row.id, voucherName: row.name },
      });
    },
    getList(pageCurrent) {
      if (pageCurrent) {
        this.page.current = pageCurrent;
      }
      this.isLoading = true;
      let params = {
        current: this.page.current,
        size: this.page.size,
      };
      params = Object.assign(params, this.searchForm);
      if (params.useLimitStart && typeof params.useLimitStart !== "number") {
        this.searchForm.useLimitStart = "";
        delete params.useLimitStart;
      }
      if (params.useLimitEnd && typeof params.useLimitEnd !== "number") {
        this.searchForm.useLimitEnd = "";
        delete params.useLimitEnd;
      }
      if (params.searchTime) {
        params.startDate = dayjs(params.searchTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.endDate = dayjs(params.searchTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete params.searchTime;
      }
      getVoucherInfoPage(params)
        .then((res) => {
          this.tableData = res.records ? _.cloneDeep(res.records) : [];
          this.page.total = res.total || 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.searchForm = {
        name: "",
        searchTime: "",
        useLimitStart: "",
        useLimitEnd: "",
        state: "",
      };
      this.getList(1);
    },
    getExpireTime(e) {
      return e ? dayjs(e).valueOf() : 0;
    },
    getExpireTimeStr(e) {
      // 距今时间 天-时-分
      const now = dayjs();
      const end = dayjs(e);
      const diff = end.diff(now, "days", true);
      if (diff < 0) {
        return "已过期";
      } else {
        const day = Math.floor(diff);
        const hour = Math.floor((diff - day) * 24);
        const minute = Math.floor((diff - day - hour / 24) * 24 * 60);
        return `${day}天${hour < 10 ? "0" + hour : hour}小时${
          minute < 10 ? "0" + minute : minute
        }分钟`;
      }
    },
  },
};
</script>
<style>
/* 自定义消息框图标位置 */
.top-icon-messagebox {
  .el-message-box__status {
    position: absolute;
    top: 12px; /* 根据需要调整距离 */
    left: 3px;
  }
  .el-message-box__message {
    padding-left: 26px !important;
  }
}
</style>
<style scoped lang="scss">
.pl-sales-statistic-table {
  background-color: #fff;
  height: 100%;
  padding: 10px;
}
::v-deep.zt__table {
  .el-table {
    height: calc(100% - 110px) !important;
    position: relative;
  }
}
</style>
